import { useState } from "react";
import {
    Box,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import Last24hCalls from "components/misc/Last24hCalls";
import CustomerDetail from "components/misc/CustomerDetail";

export default function Data() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleCustomerClick = (customerID) => {
        setSelectedCustomer(customerID);
        onOpen();
    };

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Card mb="20px" p={4}>
                <Last24hCalls showAllCustomers={true} onCustomerClick={handleCustomerClick} />
            </Card>

            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay
                    bg="blackAlpha.300"
                    backdropFilter="blur(10px) hue-rotate(90deg)"
                />
                <ModalContent maxW="80vw">
                    <ModalHeader>Customer Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {selectedCustomer && <CustomerDetail id={selectedCustomer} />}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    );
}
